import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Loader2, Store, ShieldCheck, ShieldOff, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "full", timeStyle: "short" }) : "-");

export default function AdminMarketDay() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = () => { setLoading(true); api.get("/admin/market-day").then((r) => setStatus(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const toggle = async (enabled) => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/market-day", { enabled });
      setStatus(data);
      toast.success(enabled ? "Mode Market Day AKTIF — batas unit dinonaktifkan hari ini" : "Mode Market Day dimatikan — batas unit kembali normal");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const active = status?.active;

  return (
    <div>
      <PageHeader title="Mode Market Day" subtitle="Nonaktifkan sementara pembatasan unit (Putra/Putri) di kasir Kopontren. Otomatis mati di akhir hari ini." />

      {loading ? (
        <div className="py-16 flex justify-center"><Loader2 className="animate-spin text-emerald-600" /></div>
      ) : (
        <div className="max-w-2xl">
          <div className={`rounded-2xl border p-6 shadow-sm ${active ? "bg-amber-50 border-amber-300" : "bg-white border-stone-200"}`} data-testid="market-day-card">
            <div className="flex items-start gap-4">
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 ${active ? "bg-amber-100" : "bg-stone-100"}`}>
                <Store size={26} className={active ? "text-amber-600" : "text-stone-400"} />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <p className="font-heading text-lg font-bold text-stone-900">Status:</p>
                  <span data-testid="market-day-status" className={`text-sm font-bold rounded-full px-3 py-0.5 ${active ? "bg-amber-500 text-white" : "bg-stone-200 text-stone-600"}`}>
                    {active ? "AKTIF" : "NONAKTIF"}
                  </span>
                </div>
                {active ? (
                  <p className="text-sm text-amber-800 mt-2">
                    Santri Putra & Putri dapat berbelanja di kasir mana pun tanpa batas unit. Berlaku sampai <b>{fmt(status.until)}</b> lalu otomatis kembali normal.
                  </p>
                ) : (
                  <p className="text-sm text-stone-500 mt-2">
                    Pembatasan unit aktif: santri hanya bisa belanja di kasir unitnya sendiri (Putra di kasir Putra, Putri di kasir Putri).
                  </p>
                )}
              </div>
            </div>

            <div className="mt-6 flex items-center gap-3">
              {active ? (
                <Button onClick={() => toggle(false)} disabled={busy} data-testid="market-day-disable" variant="outline" className="rounded-xl border-rose-200 text-rose-700">
                  {busy ? <Loader2 size={16} className="animate-spin mr-2" /> : <ShieldOff size={16} className="mr-2" />} Matikan Sekarang (kembali dibedakan)
                </Button>
              ) : (
                <Button onClick={() => toggle(true)} disabled={busy} data-testid="market-day-enable" className="rounded-xl bg-amber-500 hover:bg-amber-600 text-white">
                  {busy ? <Loader2 size={16} className="animate-spin mr-2" /> : <ShieldCheck size={16} className="mr-2" />} Aktifkan Market Day (hari ini)
                </Button>
              )}
            </div>
          </div>

          <div className="mt-4 rounded-xl bg-sky-50 border border-sky-200 p-4 flex gap-2 text-sm text-sky-800">
            <AlertTriangle size={16} className="mt-0.5 shrink-0" />
            <p>Mode ini otomatis nonaktif di akhir hari ini (waktu WIB). Anda tidak perlu mematikannya manual — cukup nyalakan sekali untuk acara hari ini.</p>
          </div>
        </div>
      )}
    </div>
  );
}
